export function accordionSectionsWithSelection(
  values: Record<string, string[]>,
  items: { value: string }[],
  alwaysOpenKeys: string[] = []
): string[] {
  return items
    .filter((item) => alwaysOpenKeys.includes(item.value) || (values[item.value]?.length ?? 0) > 0)
    .map((item) => item.value);
}
